import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";
const moduleName = "productionPlan"; // 生产计划

store.registerModule(moduleName, {
  namespaced: true,
  actions: {
    //获取生产计划列表
    async getProductionList(a, payload) {
      let result = await api.get(
        `/api/CostPlan?Year=${payload.Year}&PageIndex=${
          payload.PageIndex
        }&PageSize=${payload.PageSize}`
      );
      return result.data.list;
    },
    //删除数据
    async delProductionList(a, payload) {
      let result = await api.delete(`/api/CostPlan/${payload}`);
      return result;
    },
    //添加
    async addProductionList(a, payload) {
      let result = await api.post("/api/CostPlan", payload);
      return result.data;
    },
    //修改质检管理
    async editProductionList(a, payload) {
      let result = await api.put(`/api/CostPlan?id=${payload.id}`, payload);
      return result.data;
    }
  }
});

export default moduleName;
